<template>
  <restaurantProductsCategorie :typeEndPoint="'restaurantProductsCategoriesForm'" :dataParams="{}" />
</template>
<script>
import restaurantProductsCategorie from '@/components/modules/restaurant/products/categories/form'
export default {
  name: 'restaurantProductsCategories',
  components: {
    restaurantProductsCategorie
  },
  mounted () {
    console.log(this.$route.params)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/restaurant/products/categories/create.vue